import React, { useEffect, useState } from "react";
import { db } from '../../firebase/firebase';
import { ref, onValue } from 'firebase/database';
import { NavLink, Link } from 'react-router-dom';


function extractPreviewData(htmlContent) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(htmlContent, "text/html");

    const image = doc.querySelector('img'); // Gets the first <img> element
    const header = doc.querySelector('h1'); // Gets the first <h1> element

    return {
        imageUrl: image ? image.src : null,
        headerText: header ? header.innerText : "No Title"
    };
}

export default function Posts() {
    const [posts, setPosts] = useState([]);

    useEffect(() => {
        const postsRef = ref(db, 'posts/en');
        onValue(postsRef, (snapshot) => {
            const data = snapshot.val();
            const loadedPosts = [];
            if (data) {
                Object.keys(data).forEach(key => {
                    const previewData = extractPreviewData(data[key].content);
                    loadedPosts.push({
                        id: key,
                        content: data[key].content,
                        headerText: data[key].postTitle,
                        imageUrl: data[key].imgPreview,
                        timestamp: new Date(data[key].timestamp).toLocaleString()
                    });
                });
            }
            setPosts(loadedPosts.reverse());
        });
    }, []);
    return (
        <>
        <Link style={{
            fontSize: '12pt',
            fontFamily: 'Arial',
            boxShadow: '0px 0px 5px 3px #0086a1 inset',
            padding: '5px 20px',
            borderRadius: '5px',
            fontWeight: 'bold',
            marginBottom: '20px',
            display: 'block',
            width: 150
        }} to='/admin/new-post' >New Post</Link>
        <div style={{display: 'flex', flexDirection: 'row', flexWrap: 'wrap', gap: 15}}>
            {posts.map((post) => (
                <NavLink key={post.id} to={`/admin/edit-post/${post.id}`}>
                    <div style={{
                        width: '250px',
                        height: '250px',
                        overflow: 'hidden',
                        borderRadius: '10px',
                        backgroundColor: '#F3EAD3',
                        boxShadow: '0px 0px 5px 0px gray'
                    }}>
                        <img style={{
                            width: '250px',
                            height: '200px'
                        }} src={post.imageUrl} alt="" />
                        <h2 style={{
                            fontSize: '12pt',
                            width: '250px',
                            textAlign: 'center',
                            padding: '5px 5px',
                            fontFamily: 'Arial'
                        }}>{post.headerText}</h2>
                    </div>
                </NavLink>
            ))}
        </div>
        </>
    )
}